import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconArchiveJunk: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="archive-junk"><path d="M20.25 7.75V20.25H3.75V7.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M2.75 3.75H21.25V7.75H2.75V3.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M9.5 11.5L14.5 16.5M14.5 11.5L9.5 16.5" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconArchiveJunk;
